import { render, staticRenderFns } from "./Imofalform3itemsFormHeader.vue?vue&type=template&id=333ccb94"
import script from "./Imofalform3itemsFormHeader.vue?vue&type=script&lang=js"
export * from "./Imofalform3itemsFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports